import React from 'react';
import { XIcon } from 'lucide-react';
interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyPolicyModal({
  isOpen,
  onClose
}: PrivacyPolicyModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-141">
      <div className="relative w-full max-w-4xl bg-gray-900 border-2 border-yellow-600/30 rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto" data-id="element-142">
        {/* Close button */}
        <button onClick={onClose} className="sticky top-4 float-right mr-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 hover:bg-gray-700 transition-colors z-10" data-id="element-143">
          <XIcon className="w-5 h-5 text-gray-400" data-id="element-144" />
        </button>

        {/* Content */}
        <div className="p-8 md:p-12" data-id="element-145">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-146">
            Política de{' '}
            <span className="bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent" data-id="element-147">
              Privacidad y Protección de Datos
            </span>
          </h1>

          <div className="space-y-6 text-gray-300" data-id="element-148">
            {/* 1. INTRODUCCIÓN */}
            <section data-id="element-149">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-150">
                1. INTRODUCCIÓN
              </h2>
              <p className="leading-relaxed" data-id="element-151">
                En PromRed valoramos y respetamos la privacidad de nuestros
                usuarios. Esta Política de Privacidad describe cómo recopilamos,
                utilizamos, almacenamos y protegemos los datos personales que
                usted nos proporciona al utilizar nuestros sitios, APPs,
                terminales de autoatención u otros sistemas o canales de
                comunicación.
              </p>
            </section>

            {/* 2. RESPONSABLE DEL TRATAMIENTO */}
            <section data-id="element-152">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-153">
                2. RESPONSABLE DEL TRATAMIENTO
              </h2>
              <ul className="space-y-2 leading-relaxed" data-id="element-154">
                <li data-id="element-155">
                  <strong className="text-yellow-400" data-id="element-156">
                    Nombre de la entidad:
                  </strong>{' '}
                  Promred SAS
                </li>
                <li data-id="element-157">
                  <strong className="text-yellow-400" data-id="element-158">Dirección Legal:</strong>{' '}
                  Edificio The Point, Oficina 1803, Puerto Santa Ana, Guayaquil,
                  Ecuador.
                </li>
                <li data-id="element-159">
                  <strong className="text-yellow-400" data-id="element-160">
                    Correo electrónico de contacto:
                  </strong>{' '}
                  contacto@promred.ec
                </li>
              </ul>
            </section>

            {/* 3. DATOS PERSONALES QUE RECOPILAMOS */}
            <section data-id="element-161">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-162">
                3. DATOS PERSONALES QUE RECOPILAMOS
              </h2>
              <p className="mb-3 leading-relaxed" data-id="element-163">
                Podemos recopilar los siguientes datos personales cuando navegas
                o interactúas con nuestro sitio web u otros canales:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-164">
                <li data-id="element-165">Nombres y apellidos</li>
                <li data-id="element-166">Número de Cédula</li>
                <li data-id="element-167">Correo electrónico</li>
                <li data-id="element-168">Número de teléfono</li>
                <li data-id="element-169">
                  Dirección IP y datos de navegación (cookies, ubicación, tipo
                  de navegador)
                </li>
                <li data-id="element-170">
                  Información proporcionada mediante formularios de contacto o
                  suscripción
                </li>
              </ul>
            </section>

            {/* 4. FINALIDAD DEL TRATAMIENTO */}
            <section data-id="element-171">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-172">
                4. FINALIDAD DEL TRATAMIENTO
              </h2>
              <p className="mb-3 leading-relaxed" data-id="element-173">
                Recopilamos tus datos con las siguientes finalidades:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-174">
                <li data-id="element-175">
                  Enviar información institucional, boletines, eventos,
                  productos y servicios
                </li>
                <li data-id="element-176">
                  Atender consultas o solicitudes realizadas a través de
                  formularios de contacto
                </li>
                <li data-id="element-177">Gestionar inscripciones a eventos o programas</li>
                <li data-id="element-178">
                  Gestionar promociones, beneficios, sistemas de fidelización y
                  otras actividades de marketing
                </li>
                <li data-id="element-179">
                  Realizar análisis estadísticos de navegación (uso de cookies)
                </li>
                <li data-id="element-180">Cumplir con obligaciones legales y regulatorias</li>
              </ul>
            </section>

            {/* 5. LEGITIMACIÓN PARA EL TRATAMIENTO */}
            <section data-id="element-181">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-182">
                5. LEGITIMACIÓN PARA EL TRATAMIENTO
              </h2>
              <p className="mb-3 leading-relaxed" data-id="element-183">
                El tratamiento de tus datos se realiza con base en:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-184">
                <li data-id="element-185">Tu consentimiento expreso</li>
                <li data-id="element-186">
                  El interés legítimo de PromRed para cumplir su misión
                  institucional
                </li>
                <li data-id="element-187">
                  El cumplimiento de obligaciones legales, según la normativa
                  ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                  Personales – LOPDP)
                </li>
              </ul>
            </section>

            {/* 6. DESTINATARIOS DE LOS DATOS */}
            <section data-id="element-188">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-189">
                6. DESTINATARIOS DE LOS DATOS
              </h2>
              <p className="mb-3 leading-relaxed" data-id="element-190">
                Tus datos personales no serán compartidos con terceros, salvo
                que:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-191">
                <li data-id="element-192">Tengamos tu consentimiento previo</li>
                <li data-id="element-193">
                  Sea requerido por autoridad competente conforme a la ley
                </li>
                <li data-id="element-194">
                  Se usen herramientas tecnológicas de terceros (por ejemplo,
                  para envío de newsletters, CRM o formularios) con contratos
                  que garantizan la protección de tus datos
                </li>
              </ul>
            </section>

            {/* 7. DERECHOS DEL TITULAR DE LOS DATOS */}
            <section data-id="element-195">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-196">
                7. DERECHOS DEL TITULAR DE LOS DATOS
              </h2>
              <p className="mb-3 leading-relaxed" data-id="element-197">Tienes derecho a:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-198">
                <li data-id="element-199">Acceder a tus datos personales</li>
                <li data-id="element-200">Rectificar datos inexactos o incompletos</li>
                <li data-id="element-201">Eliminar tus datos (cuando proceda)</li>
                <li data-id="element-202">Oponerte al tratamiento</li>
                <li data-id="element-203">Solicitar la portabilidad de tus datos</li>
                <li data-id="element-204">Revocar el consentimiento en cualquier momento</li>
              </ul>
              <p className="mt-3 leading-relaxed" data-id="element-205">
                Puedes ejercer estos derechos escribiéndonos a{' '}
                <a href="mailto:protecciondatos@promred.ec" className="text-yellow-400 hover:text-yellow-300 underline" data-id="element-206">
                  protecciondatos@promred.ec
                </a>
              </p>
            </section>

            {/* 8. USO DE COOKIES */}
            <section data-id="element-207">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-208">
                8. USO DE COOKIES
              </h2>
              <p className="leading-relaxed" data-id="element-209">
                Nuestros sitios utilizan cookies propias y de terceros para
                mejorar la experiencia de navegación y análisis del tráfico.
                Puedes aceptar, configurar o rechazar el uso de cookies desde el
                banner de consentimiento al ingresar al sitio.
              </p>
            </section>

            {/* 9. SEGURIDAD DE LA INFORMACIÓN */}
            <section data-id="element-210">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-211">
                9. SEGURIDAD DE LA INFORMACIÓN
              </h2>
              <p className="leading-relaxed" data-id="element-212">
                PromRed aplica medidas de seguridad técnicas y organizativas
                adecuadas para proteger tus datos personales contra accesos no
                autorizados, pérdida, destrucción o alteración.
              </p>
            </section>

            {/* 10. CONSERVACIÓN DE LOS DATOS */}
            <section data-id="element-213">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-214">
                10. CONSERVACIÓN DE LOS DATOS
              </h2>
              <p className="leading-relaxed" data-id="element-215">
                Tus datos serán conservados solo durante el tiempo necesario
                para cumplir con la finalidad para la que fueron recopilados o
                mientras exista una relación institucional o contractual.
                Posteriormente serán eliminados o anonimizados, según
                corresponda.
              </p>
            </section>

            {/* 11. CAMBIOS A ESTA POLÍTICA */}
            <section data-id="element-216">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-217">
                11. CAMBIOS A ESTA POLÍTICA
              </h2>
              <p className="leading-relaxed" data-id="element-218">
                Nos reservamos el derecho de modificar esta Política de
                Privacidad en cualquier momento. Cualquier cambio será publicado
                con la fecha de actualización correspondiente.
              </p>
            </section>

            {/* 12. AUTORIDAD DE CONTROL */}
            <section data-id="element-219">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-220">
                12. AUTORIDAD DE CONTROL
              </h2>
              <p className="leading-relaxed" data-id="element-221">
                Si consideras que tus derechos no han sido respetados, puedes
                presentar un reclamo ante la Autoridad de Protección de Datos
                Personales de Ecuador, la Superintendencia de Protección de
                Datos Personales.
              </p>
            </section>

            {/* 13. VIGENCIA */}
            <section data-id="element-222">
              <h2 className="text-xl font-bold text-white mb-3" data-id="element-223">
                13. VIGENCIA
              </h2>
              <p className="leading-relaxed" data-id="element-224">
                La vigencia de estas Políticas de Privacidad y Protección de
                Datos es desde el 21 de noviembre de 2025 y permanecerá vigente
                hasta que exista una nueva versión que la reemplace.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>;
}